import 'lazysizes';

function paramLazysizes() {
  window.lazySizesConfig = window.lazySizesConfig || {};
  /**
   * The loadMode can be used to constrain the allowed loading mode.
   * Possible values are :
   *   0 = don't load anything,
   *   1 = only load visible elements,
   *   2 = load also very near view elements (expand option)
   *   3 = load also not so near view elements (expand * expFactor option).
   * This value is automatically set to 3 after onload.
   * @type {number}
   */
  window.lazySizesConfig.loadMode = 1;
}

/**
 * toggleLoader
 * @param image
 * @param imageContainer
 * @param className
 * @description add loader then remove it when image loaded.
 */
function toggleLoader(image, imageContainer, className) {
  imageContainer.classList.add(className);
  image.addEventListener('load', () => {
    imageContainer.classList.remove(className);
  });
}

/**
 * bindLoaderManagement
 * @description 'lazybeforeunveil' event triggered by Lazysizes lazy loader lib.
 * Triggered when img is being loaded.
 * Put here options if needed.
 */
function bindLoaderManagement() {
  document.addEventListener('lazybeforeunveil', (e) => {
    const img = e.target;
    const imgParent = img.parentNode;

    // Case with blue logo spinner needed
    if (img.classList.contains('lazyload--logo')) {
      toggleLoader(img, imgParent, 'loading-btn');
    }
  });
}

export const lazy = () => {
  paramLazysizes();
  bindLoaderManagement();
};
